import React from 'react';
import ATable from '../../common/table';
import { permissioned } from '../../common/permissionedHoc';

const DisputesTable = (props) => {

    //Column Definition
    const columns = [{
        header: "S/N",
        id: "s-n",
        render: row => (<div>{row.viewIndex + 1}</div>),
        width: 50
    }, {
        header: "Log Code",
        accessor: "logCode",
        width: 100,
    },
    {
        header: "Issuer",
        accessor: "issuer",
        width: 130
    },
    {
        header: "Acquirer",
        accessor: "acquirer",
        width: 130
    },
    {
        header: "Customer Ref.",
        accessor: "customerReference",
        width : 130
    },
    {
        header: "Tran. Date",
        accessor: "transactionDate"
    },
    {
        header: "Tran. Amount",
        accessor: "transactionAmount",
        render :  row => { return `${row.row.transactionCurrency} ${row.row.transactionAmount}`},
         width : 130
    },
    {
        header: "Category",
        accessor: "category"
    },
    {
        header: "Status",
        accessor: "status"
    },
    {
        header: "Created",
        accessor: "createdOn"
    },
    {
        header: "Status Expires",
        accessor: "statusScheduledEndDate"
    },
    {
        header: "Region",
        accessor: "region",
        width : 160
    }
    
    ];
    return (
        <ATable
            className="-striped -highlight"
            tableData={props.tableData}
            columns={columns}
            loading={props.loading}
            onRowClick={props.onRowClick}
            onChange={props.onTableChange || null}
            manual
           {...props}
        />
    )
};

export default permissioned(DisputesTable);


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/disputesTable.js